import React from "react";

const CopyIcon = ({ fillColor }: { fillColor: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24">
    <path
      fill={fillColor}
      d="M3.172 9.172A4 4 0 0 1 6 8h3a1 1 0 1 0 0-2H6a6 6 0 1 0 0 12h3a1 1 0 1 0 0-2H6a4 4 0 0 1-2.828-6.828ZM15 6a1 1 0 1 0 0 2h3a4 4 0 1 1 0 8h-3a1 1 0 1 0 0 2h3a6 6 0 0 0 0-12h-3Zm-7 5a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2H8Z"
    />
  </svg>
);

export default CopyIcon;
